import React, { useState } from 'react'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import styled from 'styled-components'
import Responsive from '../../../assets/config/Responsive'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import RemainingCompanies from '../../../components/v2/RemainingCompanies'
import Colors from '../../../assets/styles/Colors'
import Title from '../../../components/v2/Title'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../../store'
import { HealthState, setPriorities } from '../../../store/healthSlice'
import Loader from '../../../components/Loader'
import DraggableHorizontalCard from '../../../components/v2/DraggableHorizontalCard'
import { DragDropContext, Draggable } from 'react-beautiful-dnd'
import { StrictModeDroppable } from '../../../components/v2/StrictModeDroppable'
import HealthProgressbar from '../../../components/v2/progrees-bars/HealthProgressbar'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import { AppState } from '../../../store/appSlice'

const HealthPriority = () => {
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const dispatch = useAppDispatch()
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { screenHeader } = useAppSelector((data: { health: HealthState }) => data.health)
  //

  //fake data
  const healthPaymentSchedule = {
    id: 28,
    createdAt: '2023-10-04T14:05:41.513+04:00',
    updatedAt: '2023-10-08T15:17:29.385+04:00',
    translations: {
      ge: {
        title: 'What is your priority?',
        stepName: 'პრიორიტეტული',
      },
      en: {
        title: 'What is your priority?',
        stepName: 'priority',
      },
    },
    listItems: [
      {
        id: 70,
        listId: 28,
        sort: 3,
        image: 'https://d3cd9cyzr3ifxh.cloudfront.net/icons/p.bnmaaf1p3g-for-me-and-other.svg',
        translations: {
          ge: {
            title: 'ამბულატორია',
            body: 'Lorem Ipsum is simply dummy',
          },
          en: {
            title: 'Ambulatory services',
            body: 'Lorem Ipsum is simply dummy',
          },
        },
        createdAt: '2023-10-04T14:05:41.530+04:00',
        updatedAt: '2023-10-26T14:12:31.199+04:00',
        title: 'Ambulatory services',
        body: 'Lorem Ipsum is simply dummy',
      },
      {
        id: 71,
        listId: 28,
        sort: 1,
        image: 'https://d3cd9cyzr3ifxh.cloudfront.net/icons/p.bnmaaf1p3g-for-me-and-other.svg',
        translations: {
          ge: {
            title: 'მედიკამენტები',
            body: 'Lorem Ipsum is simply dummy',
          },
          en: {
            title: 'Providing Medication',
            body: 'Lorem Ipsum is simply dummy',
          },
        },
        createdAt: '2023-10-04T14:05:41.529+04:00',
        updatedAt: '2023-10-26T15:57:36.242+04:00',
        title: 'Providing Medication',
        body: 'Lorem Ipsum is simply dummy',
      },
      {
        id: 72,
        listId: 28,
        sort: 2,
        image: 'https://d3cd9cyzr3ifxh.cloudfront.net/icons/p.bnmaaf1p3g-for-me-and-other.svg',
        translations: {
          ge: {
            title: 'ჰოსპიტალიზაცია',
            body: 'Lorem Ipsum is simply dummy',
          },
          en: {
            title: 'Hosptalization',
            body: 'Lorem Ipsum is simply dummy',
          },
        },
        createdAt: '2023-10-04T14:05:41.530+04:00',
        updatedAt: '2023-10-26T15:43:06.532+04:00',
        title: 'Hosptalization',
        body: 'Lorem Ipsum is simply dummy',
      },

      {
        id: 73,
        listId: 28,
        sort: 3,
        image: 'https://d3cd9cyzr3ifxh.cloudfront.net/icons/p.bnmaaf1p3g-for-me-and-other.svg',
        translations: {
          ge: {
            title: 'სტომატოლოგია',
            body: 'Lorem Ipsum is simply dummy',
          },
          en: {
            title: 'Dental services',
            body: 'Lorem Ipsum is simply dummy',
          },
        },
        createdAt: '2023-10-04T14:05:41.530+04:00',
        updatedAt: '2023-10-26T14:12:31.199+04:00',
        title: 'Dental services',
        body: 'Lorem Ipsum is simply dummy',
      },
    ],
  }
  //
  //
  //
  const [data, setData] = useState(healthPaymentSchedule?.listItems)
  const handleDragEnd = (result: any) => {
    if (!result.destination) return
    const items = Array.from(data)
    const [reorderData] = items.splice(result.source.index, 1)
    items.splice(result.destination.index, 0, reorderData)
    setData(items)
  }

  //
  const stepName = healthPaymentSchedule.translations[lang].stepName
  //
  const isHealthPaymentScheduleLoading = false
  //
  const mainLoading = isHealthPaymentScheduleLoading
  //
  return mainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={t('yourPriority')} />

        <HealthProgressbar stepName={stepName} />

        <Block>
          <TextBlock>{t('dragToChoosePriority')}</TextBlock>
          <DragDropContext onDragEnd={handleDragEnd}>
            {/*fix for Droppable not working in strict mode */}
            <StrictModeDroppable droppableId="draggable-cards ">
              {(provided) => (
                <Cards className="draggable-cards" {...provided.droppableProps} ref={provided.innerRef}>
                  {data?.map((item, index) => {
                    return (
                      <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
                        {(provided) => (
                          <Span {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}>
                            <DraggableHorizontalCard
                              className="horizontal-card"
                              disabled={false}
                              title={lang === 'ge' ? item.translations.ge.title : item.translations.en.title}
                              onClick={() => dispatch(setPriorities(data?.map((item) => item.id)))}
                            />
                          </Span>
                        )}
                      </Draggable>
                    )
                  })}
                  {provided.placeholder}
                </Cards>
              )}
            </StrictModeDroppable>
          </DragDropContext>

          <RemainingCompanies
            text={
              lang === 'ge'
                ? `შეთავაზებების რაოდენობა ${3}`
                : lang === 'en'
                ? `${3} Companies are left with this options`
                : ''
            }
          />
        </Block>

        <Buttons>
          <NavigationButton
            text={`${t('back')}`}
            buttonType="prev"
            onClick={() => navigate('/health-compare-companies')}
          />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={false}
            onClick={() => navigate('/health-start-date')}
          />
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}
//

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 116px;
  min-height: 100vh;
  ${Responsive.mobile} {
    padding-bottom: 50px;
  }
`
const Content = styled.div`
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`

const Block = styled.div`
  max-width: 464px;
  margin-inline: auto;
  display: flex;
  flex-direction: column;
  margin-top: 28px;
`
const TextBlock = styled.span`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  margin-bottom: 12px;
`

const Cards = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 464px;
  gap: 24px;

  ${Responsive.mobile} {
    min-width: unset;
  }
`

const Span = styled.span`
  width: 100%;

  .horizontal-card-content {
    align-items: center;
  }
`

const Buttons = styled.div`
  display: flex;
  gap: 20px;
  width: min-content;
  margin-top: 48px;
  margin-inline: auto;
  button {
    width: 175px;
  }

  ${Responsive.mobile} {
    margin-top: 40px;
    gap: 16px;
    button {
      width: 140px;
    }
  }
`

export default HealthPriority
